import React from 'react';

export const FormField = ({ id, name, label, icon: Icon, type = 'text', value, onChange, placeholder, rows }) => {
  const baseInputClass =
    'form-input w-full px-4 py-3 rounded-lg bg-bg-page border border-border-medium text-text-primary focus:outline-none focus:border-brand-primary transition-colors';

  return (
    <div className={rows ? 'mb-8' : 'mb-6'}>
      <label htmlFor={id} className="block body-small text-text-primary mb-2 font-semibold">
        <div className="flex items-center gap-2">
          <Icon className="w-4 h-4" />
          {label}
        </div>
      </label>
      {rows ? (
        <textarea
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          required
          rows={rows}
          className={`${baseInputClass} resize-none`}
          placeholder={placeholder}
        />
      ) : (
        <input
          type={type}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          required
          className={baseInputClass}
          placeholder={placeholder}
        />
      )}
    </div>
  );
};
